import { notification } from "@mtm/components";
import moment from "moment";
import { sendEmailTripRefund } from "../services/EmailNotificationService";
import { NotificationTripRefund } from "../types/EmailNotificationType";
import { ITripDetails } from "../components/ServiceUsers/Interfaces/ITripDetails";
import { getTripByRequestAssignmentId } from "../services";

const EmailTripRefund = async (
  tripRefund: NotificationTripRefund,
  requestAssignmentId: number,
  personId: number
) => {
  try {
    const apiResponse = await getTripByRequestAssignmentId({
      requestAssignmentId: requestAssignmentId,
      personId: personId,
      favoriteId: 0,
      tripDate: moment.utc(tripRefund.serviceDate).format(),
    });
    const tripLegs = apiResponse.personTrips.sort(
      (a: ITripDetails, b: ITripDetails) =>
        a.bookingId.localeCompare(b.bookingId)
    );
    
    tripRefund.serviceDate = moment(tripLegs[0].tripDate).format("MM/DD/YYYY");
    tripRefund.sourceSystemId = tripLegs[0].sourceSystemId;
    await sendEmailTripRefund(tripRefund);
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to send email.",
    });
  }
};

export default EmailTripRefund;
